import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';

var STATES;

(function (STATES) {
  STATES["entering"] = "entering";
  STATES["exited"] = "exited";
  STATES["exiting"] = "exiting";
  STATES["entered"] = "entered";
  STATES["unmounted"] = "unmounted";
})(STATES || (STATES = {}));

var TransitionHandler = /*#__PURE__*/function () {
  function TransitionHandler() {
    var _this = this;

    _classCallCheck(this, TransitionHandler);

    // this creates an Object of type ITransitionState; init is the state that is set to true, all other
    // properties are false. Example: makeTransitionState(STATES.exiting) returns this object:
    // {entering: false, exiting: false, entered: false, unmounted: false, exited: true}
    this.makeTransitionState = function (init) {
      return Object.assign(Object.assign({}, Object.keys(STATES).filter(function (state) {
        return state !== init;
      }).reduce(function (acc, curr) {
        return Object.assign(Object.assign({}, acc), _defineProperty({}, curr, false));
      }, {})), _defineProperty({}, init, true));
    }; // This is the main routine to perform a transition. A transition consists of a workflow of states.
    // Example: Layer: Use the Timeout Function to place a Background, for example
    // The initialTransitionState could be:{entering: false, exited: false, exiting: false, entered: false, unmounted: true}
    // Open a layer with the command:
    // transition(true, 100,initialTransitionState, <listeners>)
    // the Lifecycle is:
    // onChange(this.makeTransitionState(STATES.exited)) <-- only when previous state was unmounted
    // onChanged(this.makeTransitionState(STATES.entering))
    // < timeout of saveTimeout.enter >
    // onChange(this.makeTransitionState(STATES.entered))
    //
    // Close the Layer with the command:
    // transition(false, 100, <current transition state>, <listeners>)
    // the Lifecycle is:
    // onChange(this.makeTransitionState(STATES.exiting))
    // onChanged(this.makeTransitionState(STATES.exited))
    // < timeout of saveTimeout.exit >
    // onChange(this.makeTransitionState(STATES.unmounted))
    //
    // Also have a look at DrawerWrapper for reference. The transitionState is used as a state property,
    // causing a rendering on any onChange() event.


    this.transition = function (isEnter, timeout, prevState) {
      var onChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
        /* empty */
      };
      var saveTimeout = typeof timeout === "number" ? {
        enter: timeout,
        exit: timeout
      } : timeout;

      var performEnter = function performEnter() {
        onChange(_this.makeTransitionState(STATES.entering));
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          onChange(_this.makeTransitionState(STATES.entered));
        }, saveTimeout.enter);
      };

      var performExit = function performExit() {
        onChange(_this.makeTransitionState(STATES.exiting));
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          onChange(_this.makeTransitionState(STATES.exited));
          _this.timeout = setTimeout(function () {
            onChange(_this.makeTransitionState(STATES.unmounted));
          }, 0);
        }, saveTimeout.exit);
      };

      if (isEnter) {
        if (prevState.unmounted) {
          onChange(_this.makeTransitionState(STATES.exited));
          _this.timeout = setTimeout(performEnter, 0);
        }

        if (prevState.exited || prevState.exiting) {
          performEnter();
        }
      } else if (prevState.entered || prevState.entering) {
        performExit();
      }
    };
  }

  _createClass(TransitionHandler, [{
    key: "stopTransitions",
    value: function stopTransitions() {
      // always stop an existing timeout in componentWillUnmount() to prevent "Set state on unmounted Component" error
      clearTimeout(this.timeout);
    }
  }]);

  return TransitionHandler;
}();

export { TransitionHandler };
